export default __webpack_public_path__ + "static/media/AuthImage.3a39f44e.jpg";